export interface LearnositySessionResponsesInterface {
  meta: {
    status: boolean;
    timestamp: number;
    next: string;
    versions: {
      requested: string;
      mapped: string;
      concrete: string;
    };
    records: number;
  };
  data: LearnositySessionResponsesDataInterface[];
}

export enum LearnosityResponseStatusEnum {
  COMPLETED = 'Completed',
  INCOMPLETE = 'Incomplete',
  DISCARDED = 'Discarded',
  SCORING = 'Pending Scoring',
}

export interface LearnositySessionResponsesDataInterface {
  user_id: string;
  activity_id: string;
  num_attempted: number;
  num_questions: number;
  session_id: string;
  score: number | null;
  max_score: number;
  subscores: LearnositySessionResponsesSubscoreInterface[];
  session_duration: number;
  status: LearnosityResponseStatusEnum;
  dt_event: string;
  dt_saved: string;
  dt_started: string;
  dt_completed: string;
  responses: LearnositySessionResponsesDataResponseInterface[];
  items: LearnositySessionResponsesDataItemInterface[];
  metadata: {
    activity_template_id: string;
    items_api_version: string;
    max_time: number;
    user_agent: string;
  };
}

export interface LearnositySessionResponsesDataResponseInterface {
  response_id: string;
  question_type: string;
  dt_score_updated: string;
  automarkable: boolean;
  attempted: boolean;
  score: number | null;
  max_score: number;
  question_reference: string;
  item_reference: string;
  response: {
    // question-type dependent
    apiVersion: string;
    feedbackAttemptsCount: number;
    revision: number;
    type: string;
    value: any;
  };
}

export interface LearnositySessionResponsesDataItemInterface {
  reference: string;
  source: {
    reference: string;
    organisation_id: number;
  };
  time: number;
  response_ids: string[];
  user_flagged: boolean;
  attempt_status: string; // not sure what the possible values are, but there is fully_attempted and not_attempted so far
  scoring: {
    score: number | null;
    max_score: number;
    type: string; // per-question, don't know what other values are possible
    max_score_of_attempted: number;
    max_score_of_unmarked: number;
    meta: {
      scoring_version_used: string;
    };
    attempted: boolean;
    unmarked: boolean;
  };
}

export interface LearnositySessionResponsesSubscoreInterface {
  id: string;
  title: string;
  num_questions: number;
  num_attempted: number;
  score: number;
  max_score: number;
  attempted_max_score: number;
  items: string[];
}
